import { IFile } from '@shared/interfaces/file';
import { tryParseDate } from '@shared/functions/try-parse-date';
import { ElectricMeter } from '@shared/models/electric-meter';
import { InvoicePosition } from '@shared/models/invoice-position';
import { Boat } from '@shared/models/boat';
import { ElectricMeterAssignment, IElectricMeterAssignment } from '@shared/models/electric-meter-assignment';
import { v4 as uuidv4 } from 'uuid';
import { ElectricMeterProductType } from '@shared/models/electric-meter-product-type';

export interface IReadingRaw {
    id: number;
    startDate: string;
    startMeterReading: number;
    endDate: string;
    endMeterReading: number;
    image: IFile;
    endImage: IFile;
    reason: string;
    note: string;
    electricMeter?: any;
    invoicePosition?: any;
    boat?: any;
    productType: ElectricMeterProductType;
    bcm_electric_meters_id: number;
    electricMeterAssignments?: IElectricMeterAssignment[];
    electricMeterAssignment?: IElectricMeterAssignment;
    uuid?: string;
}

export interface IReading {
    id: number;
    startDate: Date;
    startMeterReading: number;
    endDate: Date;
    endMeterReading: number;
    image: IFile;
    endImage: IFile;
    reason: string;
    note: string;
    productType: ElectricMeterProductType;
    boat?: Boat;
    bcm_electric_meters_id: number;
    electricMeterAssignments?: ElectricMeterAssignment[];
    electricMeterAssignment?: ElectricMeterAssignment;
    uuid?: string;
    hasActiveAssignment?: boolean;
    // insertedOn: string;
    // insertedBy: string;
    // lastUpdateOn: string;
    // lastUpdateBy: string;
}

export class Reading {
    id: number;
    startDate: Date;
    startMeterReading: number;
    endDate: Date;
    endMeterReading: number;
    image: IFile;
    endImage: IFile;
    reason: string;
    note: string;
    productType: ElectricMeterProductType;

    electricMeterAssignments?: ElectricMeterAssignment[];
    electricMeterAssignment?: ElectricMeterAssignment | null;

    // tslint:disable-next-line:variable-name
    bcm_electric_meters_id: number;
    electricMeter?: ElectricMeter;
    invoicePosition?: InvoicePosition | null;
    boat?: Boat | null;
    active?: boolean;
    uuid?: string;

    hasActiveAssignment?: boolean;

    constructor(reading: IReadingRaw) {
        this.id = reading.id || undefined;
        this.startDate = tryParseDate(reading.startDate, undefined);
        this.endDate = tryParseDate(reading.endDate, undefined);
        this.startMeterReading = reading.startMeterReading;
        this.endMeterReading = reading.endMeterReading;
        this.image = reading.image;
        this.endImage = reading.endImage;
        this.reason = reading.reason;
        this.note = reading.note;
        this.electricMeter = reading.electricMeter;
        this.invoicePosition = reading.invoicePosition ? new InvoicePosition(reading.invoicePosition) : null;
        this.boat = reading.boat ? new Boat(reading.boat) : null;
        this.productType = reading.productType;
        this.bcm_electric_meters_id = reading.bcm_electric_meters_id;

        this.electricMeterAssignments = (reading.electricMeterAssignments || []).map(assignment => {
            return new ElectricMeterAssignment(assignment);
        });
        this.electricMeterAssignment = reading.electricMeterAssignment
            ? new ElectricMeterAssignment(reading.electricMeterAssignment)
            : null;

        const today = new Date();
        this.active = (this.startDate.getTime() <= today.getTime()) && (this.endDate == null || this.endDate.getTime() >= today.getTime());
        this.uuid = reading.uuid || uuidv4();
    }

}
